module.exports = __webpack_public_path__ + "d6061d027b90e23fb3189ed43f90ef13.svg";